export default {"src":"/_next/static/media/black-square-meters.8746895a.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};